<template>
  <div class="animated fadeIn">
    <div class="row pb-3">
        <div class="col-12 text-center">
          <b-card-group deck>
            <b-card class="text-center pb-2 pointer" style="max-width: 25%;">
              <i v-if="this.campaign && this.campaign.plataforma && this.campaign.plataforma === 1" class="fas fa-mail-bulk pt-4 text-third" style="font-size: 50px" />
              <i v-else-if="this.campaign && this.campaign.plataforma && this.campaign.plataforma === 2" class="fas fa-sms pt-4 text-third" style="font-size: 50px" />
              <i v-else-if="this.campaign && this.campaign.plataforma && this.campaign.plataforma === 3" class="fab fa-whatsapp pt-4 text-third" style="font-size: 50px"></i>
              <i class="fas fa-sms d-none"></i>
              <h4 v-if="this.campaign && this.campaign.plataforma && this.campaign.plataforma === 1" class="pt-3 text-default">E-mail</h4>
              <h4 v-else-if="this.campaign && this.campaign.plataforma && this.campaign.plataforma === 2" class="pt-3 text-default">SMS</h4>
              <h4 v-else-if="this.campaign && this.campaign.plataforma && this.campaign.plataforma === 3" class="pt-3 text-default">WhatsApp</h4>
              <div>Canal</div>
            </b-card>
            <b-card class="text-center pb-2 pointer" style="max-width: 25%;">
              <i class="fas fa-users pt-4 text-third" style="font-size: 50px" />
              <h4 class="pt-3 text-default">{{ totalContato }}</h4>
              <div>Total de contatos</div>
            </b-card>
            <b-card class="text-center pb-2 pointer" style="max-width: 25%;">
              <i class="fas fa-paper-plane pt-4 text-third" style="font-size: 50px" />
              <h4 class="pt-3 text-default"> {{ totalEnviado }}%</h4>
              <div class="d-flex align-items-center justify-content-center" ><h6 v-if="report" class="m-0 mr-1"> {{ report.totalEnviado }}</h6> Enviados</div>
            </b-card>
            <b-card class="text-center pb-2 pointer" style="max-width: 25%;">
              <i class="fas fa-envelope-open-text pt-4 text-third" style="font-size: 50px" />
              <h4 class="pt-3 text-default">{{ totalVisualizado }}</h4>
              <div class="d-flex align-items-center justify-content-center" >Visualizações</div>
            </b-card>
            <b-card class="text-center pb-2 pointer" style="max-width: 25%;">
              <i class="fas fa-user-check pt-4 text-third" style="font-size: 50px" />
              <h4 class="pt-3 text-default">{{ totalConvertido }}%</h4>
              <div class="d-flex align-items-center justify-content-center" ><h6 v-if="report" class="m-0 mr-1">{{ report.totalConvertido }}</h6> Clicks</div>
            </b-card>
          </b-card-group>
        </div>
      </div>
    <Tables ref="tableGrid"
            :columns="['CPF/CNPJ', 'Nome', 'E-mail', 'Telefone', 'Visualizou', 'Data 1ª Visualização', 'Data Ult. Visualização', 'Clicou', 'Data Click', 'Data Disparo']"
            :showTipFooter="false"
            :showBack="true"
            :showReload="true"
            v-on:Back="$emit('Back')"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.documento" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.nome ? obj.nome.toUpperCase() : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.email ? obj.email.toLowerCase() : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.celular" />
        <TableColumn :IsCustom="true">
          <a href="javascript:void(0)" class="" v-if="obj.quantidadeVisualizacao === 0"><span>NÃO</span></a>
          <a href="javascript:void(0)" class="" v-else><span>{{obj.quantidadeVisualizacao}}x</span></a>
        </TableColumn>
        <TableColumn :IsDatetime="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.dataPrimeiraVisualizacao" />
        <TableColumn :IsDatetime="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.dataUltimaVisualizacao" />
        <TableColumn :IsCustom="true">
          <b-badge variant="success" v-if="obj.conversao">SIM</b-badge>
          <b-badge variant="secondary" v-else>NÃO</b-badge>
        </TableColumn>
        <TableColumn :IsDatetime="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.dataConversao" />
        <TableColumn :IsDatetime="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.dataEnvioRealizado" />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 text-right">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('Back')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonBack"><i class="fas fa-undo"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Back}}</span></button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import CampaignSentRepository from '@/shared/http/repositories/campaign/campaignsent.js'

export default {
  name: 'CampaignReport',
  mixins: [ActionsForm],
  data () {
    return {
      campaign: null,
      report: null
    }
  },
  computed: {
    plataformaCode: function () {
      let result = null
      if (this.campaign && this.campaign.plataforma) {
        result = this.campaign.plataforma
      }
      return result
    },
    totalContato: function () {
      let result = 0
      if (this.report) {
        result = this.report.totalContato
      }
      return result
    },
    totalEnviado: function () {
      let result = 0
      if (this.report) {
        result = Math.round((this.report.totalEnviado / this.report.totalContato) * 100)
      }
      return result
    },
    totalVisualizado: function () {
      let result = 0
      if (this.report) {
        result = parseInt(this.report.totalVisualizado)
        // Ñ FAZ SENTIDO APARECER PORCENTAGEM, POIS O MESMO LEAD PODE VISUALIZAR N VEZES, FAZENDO A PORCENTAGEM PASSAR DE 100%
        // result = Math.round((this.report.totalVisualizado / this.report.totalContato) * 100)
      }
      return result
    },
    totalConvertido: function () {
      let result = 0
      if (this.report) {
        result = Math.round((this.report.totalConvertido / this.report.totalContato) * 100)
      }
      return result
    }
  },
  methods: {
    onLoad () {
      if (this.campaign) {
        this.onLoadAll()
        this.onLoadReport()
      }
    },
    onEdit (obj) {
      this.campaign = obj
      this.onLoadAll()
      this.onLoadReport()
    },
    onLoadAll () {
      if (this.campaign) {
        loading.push()
        CampaignSentRepository.Search(this.campaign.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      }
    },
    onLoadReport () {
      if (this.campaign) {
        CampaignSentRepository.Report(this.campaign.id)
          .then((response) => {
            this.report = response.data
          })
          .catch(this.onException)
      }
    }
  }
}
</script>
<style scoped>
.card {
  border-radius: 11px;
  box-shadow: 0 0 1em #ccc;
}
h4, h5 {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/private/campaign/components/report/report.vue